import {createContext} from '@lit-labs/context';
import type {Dataset} from '@gl/lit/types/datasets.js';

export const DatasetsContext = createContext<Dataset[]>('datasets-context');
